class GeoBanner {
    constructor(banner) {
        this.banner = banner;
        const showGeoBannerSetting = sessionStorage.getItem("showGeoBanner");

        if (!this.banner || showGeoBannerSetting == 'false') return;

        this.storeOptions = JSON.parse(this.banner.dataset.geoBanner);
        this.closeBtn = this.banner.querySelector('[data-geo-banner-close]');

        this.closeBtn.addEventListener('click', () => {
            this.banner.style.display = 'none';
            sessionStorage.setItem("showGeoBanner", 'false');
        });

        this.textEl = this.banner.querySelector('[data-geo-text]');
        this.texts = JSON.parse(this.textEl.dataset.geoText);

        this.maybeShowBanner();
    }

    getCurrentWebsiteCountry() {
        return window.WPDATA.currentCountry;
    }

    getCountryCode() {
        // Check if localstorage has country code
        let countryCode = this.getCookie('countryCode');

        return new Promise((resolve) => {
            if (!countryCode) {
                fetch(window.WPURLS.ajaxurl + '?action=geo')
                    .then(response => response.json())
                    .then(data => {
                        const d = new Date();
                        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000); //365 days

                        this.setCookie('countryCode', data, { domain: window.WPDATA.domain, expires: d });
                        resolve(data);
                    });
            } else {
                resolve(countryCode);
            }
        });

    }

    getClientIp() {
        return window.WPDATA.ip;
    }

    async maybeShowBanner() {
        const countryCode = await this.getCountryCode();
        const websiteCountry = this.getCurrentWebsiteCountry();

        if (countryCode !== undefined && countryCode !== websiteCountry) {
            this.banner.style.display = 'block';

            // Check if country is in store options
            if (this.storeOptions.hasOwnProperty(countryCode)) {
                let text = this.texts.shippable;
                text = text.replaceAll('{{countryCode}}', countryCode);
                text = text.replaceAll('{{fullCountry}}', this.storeOptions[countryCode]);
                this.textEl.innerHTML = text;
            } else {
                let text = this.texts.unshippable;
                text = text.replaceAll('{{countryCode}}', countryCode);
                text = text.replaceAll('{{fullCountry}}', this.storeOptions[countryCode]);
                this.textEl.innerHTML = text;
            }


            // If not, show default message
        }
    }

    getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    setCookie(name, value, attributes = {}) {

        attributes = {
            path: '/',
            // add other defaults here if necessary
            ...attributes
        };

        if (attributes.expires instanceof Date) {
            attributes.expires = attributes.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let attributeKey in attributes) {
            updatedCookie += "; " + attributeKey;
            let attributeValue = attributes[attributeKey];
            if (attributeValue !== true) {
                updatedCookie += "=" + attributeValue;
            }
        }

        document.cookie = updatedCookie;
    }
}

export default class GeoBanners {
    constructor() {
        document.addEventListener('bless', (e) => {
            this.container = e.detail.element;
            this.init(this.container);
        });
    }

    init(container) {
        const banner = container.querySelector('[data-geo-banner]');
        if (banner) {
            new GeoBanner(banner);
        }
    }
}